// document.addEventListener("DOMContentLoaded", () => {
//   const toast = document.getElementById("cart-toast");
//   const closeBtn = toast?.querySelector(".cart-toast__close");
//   const productNameEl = document.getElementById("cart-toast-product");

//   if (!toast || !closeBtn || !productNameEl) return;

//   const showToast = (name) => {
//     clearTimeout(toast.timeoutId);
//     clearTimeout(toast.exitTimeout);

//     toast.classList.remove("active", "exit");
//     void toast.offsetWidth; // Force reflow

//     productNameEl.textContent = name;
//     toast.classList.add("active");

//     toast.timeoutId = setTimeout(() => {
//       toast.classList.add("exit");
//       toast.exitTimeout = setTimeout(() => {
//         toast.classList.remove("active", "exit");
//       }, 400);
//     }, 2000);
//   };

//   const hideToast = () => {
//     clearTimeout(toast.timeoutId);
//     clearTimeout(toast.exitTimeout);
//     toast.classList.add("exit");
//     toast.exitTimeout = setTimeout(() => {
//       toast.classList.remove("active", "exit");
//     }, 400);
//   };

//   document.querySelectorAll('button[name="plus"]').forEach((btn) =>
//     btn.addEventListener("click", () => {
//       const productName = btn.dataset.name || "Item";
//       showToast(productName);
//     })
//   );

//   closeBtn.addEventListener("click", hideToast);
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const toast = document.getElementById("cart-toast");
//   const closeBtn = toast?.querySelector(".cart-toast__close");
//   const productNameEl = document.getElementById("cart-toast-product");

//   if (!toast || !closeBtn || !productNameEl) return;

//   const showToast = (text) => {
//     clearTimeout(toast.timeoutId);
//     clearTimeout(toast.exitTimeout);

//     toast.classList.remove("active", "exit");
//     void toast.offsetWidth; // Force reflow

//     productNameEl.textContent = text;
//     toast.classList.add("active");

//     toast.timeoutId = setTimeout(() => {
//       toast.classList.add("exit");
//       toast.exitTimeout = setTimeout(() => {
//         toast.classList.remove("active", "exit");
//       }, 400);
//     }, 2000);
//   };

//   const hideToast = () => {
//     clearTimeout(toast.timeoutId);
//     clearTimeout(toast.exitTimeout);
//     toast.classList.add("exit");
//     toast.exitTimeout = setTimeout(() => {
//       toast.classList.remove("active", "exit");
//     }, 400);
//   };

//   // Update toast to display plus button data dynamically
//   document.querySelectorAll('button[name="plus"]').forEach((btn) =>
//     btn.addEventListener("click", () => {
//       const pro = btn.dataset.pro || "";
//       const group = btn.dataset.group || "";
//       const name = btn.dataset.name || "";

//       // Format: data-pro(data-group: data-name)
//       const toastText = `${pro} (${group}: ${name})`;
//       showToast(toastText);
//     })
//   );

//   closeBtn.addEventListener("click", hideToast);
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const toast = document.getElementById("cart-toast");
//   const closeBtn = toast?.querySelector(".cart-toast__close");
//   const productNameEl = document.getElementById("cart-toast-product");

//   if (!toast || !closeBtn || !productNameEl) return;

//   const showToast = (text) => {
//     clearTimeout(toast.timeoutId);
//     clearTimeout(toast.exitTimeout);

//     toast.classList.remove("active", "exit");
//     void toast.offsetWidth; // Force reflow

//     productNameEl.textContent = text;
//     toast.classList.add("active");

//     toast.timeoutId = setTimeout(() => {
//       toast.classList.add("exit");
//       toast.exitTimeout = setTimeout(() => {
//         toast.classList.remove("active", "exit");
//       }, 400);
//     }, 2000);
//   };

//   const hideToast = () => {
//     clearTimeout(toast.timeoutId);
//     clearTimeout(toast.exitTimeout);
//     toast.classList.add("exit");
//     toast.exitTimeout = setTimeout(() => {
//       toast.classList.remove("active", "exit");
//     }, 400);
//   };

//   // Update toast to display plus button data dynamically
//   document.querySelectorAll('button[name="plus"]').forEach((btn) =>
//     btn.addEventListener("click", () => {
//       const pro = btn.dataset.pro || "";
//       const group = btn.dataset.group || "";
//       const name = btn.dataset.name || "";

//       let toastText = pro; // Default to product name

//       // Only append variant info if it exists
//       if (group && name && group !== name) {
//         toastText += ` (${group}: ${name})`;
//       }

//       showToast(toastText);
//     })
//   );

//   closeBtn.addEventListener("click", hideToast);
// });
document.addEventListener("DOMContentLoaded", () => {
  const toast = document.getElementById("cart-toast");
  const closeBtn = toast?.querySelector(".cart-toast__close");
  const productNameEl = document.getElementById("cart-toast-product");

  if (!toast || !closeBtn || !productNameEl) return;

  const showToast = (text) => {
    clearTimeout(toast.timeoutId);
    clearTimeout(toast.exitTimeout);

    // Remove placeholder variant text like "(Title: Default Title)"
    text = text.replace(/\(\s*Title\s*:\s*Default Title\s*\)/, "").trim();

    toast.classList.remove("active", "exit");
    void toast.offsetWidth; // Force reflow

    productNameEl.textContent = text;
    toast.classList.add("active");

    toast.timeoutId = setTimeout(() => {
      toast.classList.add("exit");
      toast.exitTimeout = setTimeout(() => {
        toast.classList.remove("active", "exit");
      }, 400);
    }, 2000);
  };

  const hideToast = () => {
    clearTimeout(toast.timeoutId);
    clearTimeout(toast.exitTimeout);
    toast.classList.add("exit");
    toast.exitTimeout = setTimeout(() => {
      toast.classList.remove("active", "exit");
    }, 400);
  };

  document.querySelectorAll('button[name="plus"]').forEach((btn) =>
    btn.addEventListener("click", () => {
      const pro = btn.dataset.pro || "";
      const group = btn.dataset.group || "";
      const name = btn.dataset.name || "";

      let toastText = pro; // default: product name

      // Append variant info only if it exists and is not placeholder
      if (!(group === "Title" && name === "Default Title") && group && name) {
        toastText += ` (${group}: ${name})`;
      }

      showToast(toastText);
    })
  );

  closeBtn.addEventListener("click", hideToast);
});
